export default __webpack_public_path__ + "static/media/gautiersegouin.cd1b56e7.png";